import type { Segment } from '@shared/types'
import { getSegmentTimeline, findSegmentAt } from '../../../lib/timelineMath'

/**
 * UI_MK2_PHASE1.md §3-3: "⌥＋クリックで再生ヘッド位置に挿入" — index passed to
 * `addSegmentFromScene`'s `insertAtIdx` is "再生ヘッドが乗っている Segment の直後".
 * Empty timeline / playhead past the last Segment both resolve to the end
 * (== `segments.length`, which `addSegmentFromScene` already treats as
 * append) so this never needs a separate "no-op" branch.
 */
export function computeInsertIndexAtPlayhead(segments: Segment[], currentSec: number): number {
  if (segments.length === 0) return 0
  const timeline = getSegmentTimeline(segments)
  const at = findSegmentAt(timeline, currentSec)
  if (!at) return segments.length
  return at.index + 1
}
